import { IconographyTypes } from '@genial/icons';

type ChartTab = {
  icon: IconographyTypes.Option;
  label: string;
  key: string;
  totalField: string;
  baseLabel: string;
};

export const chartTypeTabsInitialTab = 'composition';
export const chartTabsList: ChartTab[] = [
  {
    icon: 'Stack',
    label: 'Produtos',
    key: 'composition',
    totalField: 'totalInvested',
    baseLabel: 'Total Investido',
  },
  {
    icon: 'Alarm',
    label: 'Liquidez',
    key: 'liquidity',
    totalField: 'totalInvested',
    baseLabel: 'Total Investido',
  },
  {
    icon: 'Strategy',
    label: 'Estratégia',
    key: 'strategy',
    totalField: 'totalInvested',
    baseLabel: 'Total Investido',
  },
  {
    icon: 'Museum',
    label: 'Patrimônio',
    key: 'assets',
    totalField: 'totalNetWorth',
    baseLabel: 'Patrimônio do Cliente',
  },
  {
    icon: 'LockMoney',
    label: 'Bloqueio',
    key: 'blocking',
    totalField: 'totalBlockingAssets',
    baseLabel: 'Patrimônio do Cliente',
  },
];

export const chartTypeTabsByKey: Record<string, ChartTab> = chartTabsList.reduce((acc, tab) => {
  acc[tab.key] = tab;
  return acc;
}, {} as Record<string, ChartTab>);
